export const BANNER_CAMPAIGN = 'banner_campaign';
export const ONE_DAY_IN_MILLISECONDS = 1000 * 60 * 60 * 24;
export const DEFAULT_CAMPAIGN = 'default';
